import React from 'react';
import { useParams, Link } from 'react-router-dom';

const PaySuccess = () => {
  const { name } = useParams();
  return (
    <div className="text-2xl flex h-screen">
      <section className="m-auto drop-shadow-lg p-10 lg:p-24 rounded-lg">
        <h2 className="mb-5 drop-shadow-md">
          Thank you {name}, your payment was{' '}
          <span className="text-green-500">successful</span>{' '}
        </h2>

        <Link to="/" className="mt-10 px-3 py-1 bg-amber-400 rounded-md">
          Go Back
        </Link>
      </section>
    </div>
  );
};

export default PaySuccess;
